import React, { useState, useEffect, useRef } from "react"
import cx from "classnames"

export function Sticky({
  position = { top: -1 },
  stuckClasses = "",
  unstuckClasses = "",
  className = "",
  stuckStyles = {},
  unstuckStyles = {},
  children
}) {
  const [stuck, setStuck] = useState(false)
  const ref = useRef()

  const classes = stuck ? stuckClasses : unstuckClasses
  const styles = stuck ? stuckStyles : unstuckStyles

  const inlineStyles = {
    position: "sticky",
    ...position,
    ...styles
  }

  useEffect(() => {
    const cachedRef = ref.current
    const observer = new IntersectionObserver(
      ([e]) => setStuck(e.intersectionRatio < 1),
      { threshold: [1] }
    )
    observer.observe(cachedRef)
    return () => observer.unobserve(cachedRef)
  }, [ref])

  return (
    <div style={inlineStyles} className={cx(className, classes)} ref={ref}>
      {children}
    </div>
  )
}
